import { render, staticRenderFns } from "./CreateLocations.vue?vue&type=template&id=0826c9c0&scoped=true"
import script from "./CreateLocations.vue?vue&type=script&lang=js"
export * from "./CreateLocations.vue?vue&type=script&lang=js"
import style0 from "./CreateLocations.vue?vue&type=style&index=0&id=0826c9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0826c9c0",
  null
  
)

export default component.exports